import React from 'react';

import { appConfig } from '../../../config/app';

const Login = () => {
  let LoginPage = appConfig?.LOGIN_PAGE;

  return <LoginPage />;
};

Login.displayName = 'Login';

export default Login;
